export default [
  {
    title: 'Content',
    // icon: 'FileTextIcon',
    icon: 'file-alt',
    children: [
      {
        title: 'Overview',
        route: 'content',
      },
    ],
  },
]
